<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
<ng-container *ngIf="process$ | async as process">
  <div *ngIf="question$ | async as question">
    <h5 [ngClass]="{'field-required': question.isRequired}">
      <span>{{question.order | displayOrderPattern : process}}</span>
      <span class="separator"></span>
      {{
      question
      | propertyLocalized : ["nameAr", "nameEn"]
      | async
      }}
    </h5>

    <p>
      {{
      question
      | propertyLocalized : ["tooltipAr", "tooltipEn"]
      | async
      }}
    </p>

    <mat-checkbox [(ngModel)]="question.notApply" disabled>
      {{'forms.common.a1' | translate}}
    </mat-checkbox>

    <ng-container *ngIf="process.hasEvaluationItems">
      <div class="evaluatedItems">
        <table class="table table-bordered mb-2">
          <tr class="header">
            <th width="50%" rowspan="2"></th>
            <th rowspan="2">{{'forms.common.a1' | translate}}</th>
            <th *ngFor="let item of process.evaluationLevels">
              {{
              item
              | propertyLocalized : ["arabicLabel", "englishLabel"]
              | async
              }}
            </th>
          </tr>
          <tr class="header">
            <th *ngFor="let item of process.evaluationLevels">
              {{item.score}}
            </th>
          </tr>

          <tr *ngFor="let item of question.evaluationItems">
            <td>
              {{
              item
              | propertyLocalized : ["nameAr", "nameEn"]
              | async
              }}
              <mat-icon class="info" *ngIf="item.hasTooltip"
                [matTooltip]="item | propertyLocalized : ['tooltipAr', 'tooltipEn'] | async">
                info
              </mat-icon>
            </td>
            <td>
              <input type="radio" [(ngModel)]="item.score" [disabled]="true">
            </td>
            <td *ngFor="let option of process.evaluationLevels">
              <input type="radio" [value]="option.score" [(ngModel)]="item.score" [disabled]="true">
            </td>
          </tr>
        </table>
      </div>
    </ng-container>

    <div *ngIf="!process.hasEvaluationItems" class="answerContainer">
      <div *ngFor="let item of answers$ | async" class="disabled">
        <input class="radio" type="radio" name="answer_{{question._id}}_{{item.value}}"
          id="answer_{{question._id}}_{{item.value}}" value="{{item.value}}" required="question.isRequired"
          [disabled]="true" [(ngModel)]="question.value">
        <mat-label>
          {{item.value}}
          <mat-icon class="info" *ngIf="item.hasTooltip"
            [matTooltip]="item | propertyLocalized : ['tooltipAr', 'tooltipEn'] | async">
            info
          </mat-icon>
        </mat-label>
      </div>
    </div>

    <ng-container *ngIf="question.hasLink">
      <br />
      <div class="d-flex justify-content-between align-items-baseline">
        <mat-label class="font-weight-bold d-flex align-items-end mb-2"
          [ngClass]="{'field-required': question.linkIsRequired}">
          <mat-icon class="info" *ngIf="question.hasLinkTooltip"
            [matTooltip]="question | propertyLocalized : ['linkTooltipAr', 'linkTooltipEn'] | async">
            info
          </mat-icon>
          {{
          question
          | propertyLocalized : ["linkNameAr", "linkNameEn"]
          | async
          }}
        </mat-label>

        <span dir="ltr">
          {{question.linkValue}}
        </span>
      </div>
    </ng-container>

    <div *ngIf="question.hasNotes">
      <br />
      <mat-label class="font-weight-bold d-flex align-items-end mb-2"
        [ngClass]="{'field-required': question.notesIsRequired}">
        <mat-icon class="info" *ngIf="question.hasNotesTooltip"
          [matTooltip]="question | propertyLocalized : ['notesTooltipAr', 'notesTooltipEn'] | async">
          info
        </mat-icon>
        {{
        question
        | propertyLocalized : ["notesNameAr", "notesNameEn"]
        | async
        }}
      </mat-label>

      <p-editor [style]="{'height':'200px'}" [(ngModel)]="question.notesValue" required [readonly]="true">
      </p-editor>
    </div>

    <div *ngIf="question.hasAttachments" class="d-flex flex-column">
      <br />
      <mat-label class="font-weight-bold d-flex align-items-end mb-2" *ngIf="question.hasAttachmentsTooltip">
        {{
        question
        | propertyLocalized : ["attachmentsTooltipAr", "attachmentsTooltipEn"]
        | async
        }}
      </mat-label>

      <ng-container *ngFor="let item of question.attachments">
        <mat-label class="font-weight-bold d-flex align-items-end"
          [ngClass]="{'field-required': item.attachmentIsRequired}">
          <mat-icon class="info" *ngIf="item.hasTooltip"
            [matTooltip]="item | propertyLocalized : ['attachmentTooltipAr', 'attachmentTooltipEn'] | async">
            info
          </mat-icon>
          {{
          item
          | propertyLocalized : ["attachmentNameAr", "attachmentNameEn"]
          | async
          }}
        </mat-label>

        <formio #forms [submission]="{data:{attachments : item.data }}" [formKey]="attachmentFormKey"
          [showLoader]="false" [readOnly]="true" [viewOnly]="true">
        </formio>
        <br />
      </ng-container>
    </div>

    <div *ngIf="question.hasPledgeAndAcknowledgment">
      <br />
      <mat-label class="font-weight-bold d-flex align-items-end mb-2" *ngIf="question.hasPledgeTooltip">
        {{
        question
        | propertyLocalized : ["pledgeTooltipAr", "pledgeTooltipEn"]
        | async
        }}
      </mat-label>

      <mat-checkbox [ngClass]="{'field-required': question.pledgeIsRequired}" [(ngModel)]="question.pledgeValue"
        disabled>
        <span [innerHTML]="question | propertyLocalized : ['pledgeNameAr', 'pledgeNameEn' ] | async"></span>
      </mat-checkbox>
    </div>
  </div>
</ng-container>